import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import HomeEn from '@/components/HomeEn'

Vue.use(Router)

var r = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeEn
    },
    { path: '/images'},
  ]
});

console.log('navigator.language=' + navigator.language)

if (navigator.language.includes('es')) console.log('utilizamos es')
else console.log('utilizamos en')

if (navigator.language.includes('es')) r = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
  ]
});

export default r;



// WEBPACK FOOTER //
// ./src/router/index.js